module.exports = __webpack_public_path__ + "f8f420e7bdae9e151977ff1f08d8a78e.png";